import { FC } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import Lock from 'ui/components/Icons/Lock';
export interface CbBadgeProps extends BoxProps {
  id?: string;
  imageUrl?: string;
  isActive?: boolean;
  isSelected?: boolean;
  level?: number;
  onClick?: () => void;
  unlockedAt?: string;
}
export const CbBadge: FC<CbBadgeProps> = ({
  id,
  imageUrl,
  isActive = false,
  isSelected,
  level = 0,
  onClick,
  unlockedAt = null,
  ...props
}) => {
  const hasImage = !!imageUrl;
  const isFocused = onClick && isSelected && unlockedAt;
  return <Box as="button" onClick={onClick} position="relative" backgroundImage={`url("${imageUrl || ''}")`} backgroundPosition={hasImage ? 'center' : 'center 16px'} backgroundRepeat="no-repeat" backgroundSize="cover" backgroundColor="samus.100" borderWidth={isActive ? '3px' : '0px'} borderColor="chonky.500" borderRadius={50} cursor={onClick ? 'pointer' : 'default'} width={isFocused ? 14 : 12} height={isFocused ? 14 : 12} top={isFocused ? '-6px' : undefined} boxShadow={isSelected ? '0px 8px 10px rgba(0, 0, 0, 0.15)' : undefined} {...props} data-sentry-element="Box" data-sentry-component="CbBadge" data-sentry-source-file="CbBadge.tsx">
      <Box position="absolute" bottom={0.2} left="50%" transform="translateX(-50%)" background={!unlockedAt ? '#F2F2F2' : undefined} paddingY={3} paddingX={2} borderRadius={50} data-sentry-element="Box" data-sentry-source-file="CbBadge.tsx">
        {!unlockedAt && <Lock width="30px" height="20px" color="#D8D8D8" />}
      </Box>
    </Box>;
};